// extracted by mini-css-extract-plugin
module.exports = {"List":"SubPageList_List__10i9N","Level1":"SubPageList_Level1__3uKln","Level2":"SubPageList_Level2__3yTFG"};